import DynamicGoogleFont from "@/core/components/DynamicGoogleFont";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { Favicon } from "@/core/components/FavIcon";
import { resellerConfigQueryOptions } from "@/core/components/resellers/resellerQueryOptions";
import { AuthContext } from "@/core/context/authContext";
import { HEXToHSL } from "@/core/lib/utils";
import { QueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface RouterContext {
	queryClient: QueryClient;
	auth: AuthContext;
}

const AlbieURL = import.meta.env.VITE_ALBIE_URL as string;
const host = window.location.origin;
const IS_ALBIE = AlbieURL === host;

export const Route = createRootRouteWithContext<RouterContext>()({
	loader: ({ context: { queryClient } }) => {
		console.log(AlbieURL, host);
		if (IS_ALBIE) {
			return null;
		} else {
			return queryClient.ensureQueryData(
				resellerConfigQueryOptions(window.location.host),
			);
		}
	},
	component: RootComponent,
	pendingComponent: () => <div>Loading...</div>,
	errorComponent: ErrorComponent,
});

function RootComponent() {
	const resellerConfigResult = useSuspenseQuery(
		resellerConfigQueryOptions(IS_ALBIE ? null : window.location.host),
	);

	if (!IS_ALBIE && resellerConfigResult.data) {
		document
			.querySelector("html")
			?.style.setProperty(
				"--primary",
				HEXToHSL(resellerConfigResult.data.data.primaryColor),
			);
		document
			.querySelector("html")
			?.style.setProperty(
				"--secondary",
				HEXToHSL(resellerConfigResult.data.data.secondaryColor),
			);
		document
			.querySelector("html")
			?.style.setProperty(
				"--accent",
				HEXToHSL(resellerConfigResult.data.data.accentColor),
			);
		document
			.querySelector("html")
			?.style.setProperty("--font", resellerConfigResult.data.data.primaryFont);
	}

	return (
		<div className="text-color">
			{resellerConfigResult.data && (
				<>
					<Favicon
						icon={
							import.meta.env.VITE_IMAGE_URL +
							resellerConfigResult.data.data.favicon
						}
					/>
					<DynamicGoogleFont
						fontFamily={resellerConfigResult.data.data.primaryFont}
						weights={["400", "500", "600", "700"]}
					/>
				</>
			)}
			<Outlet />
		</div>
	);
}
